import { useAppSelector } from 'app/hooks/useStore'
import { selectLastHumanMessage } from 'app/store/AIChat/AIChat.selectors'
import { Theme, Box, CircularProgress, Paper, Typography } from '@mui/material';

export default function LoadingPlaceholder() {
  const lastHumanMessage = useAppSelector(selectLastHumanMessage);

  const renderProgress = (additionalText:boolean = false) => {
    return (
      <Paper
        sx={(theme:Theme) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.palette.primary.light,
          p: 4,
          gap: 4
        })}
        variant="outlined"
      >
        <CircularProgress thickness={4} size={32} />
        <Box>
          <Typography variant="subtitle2">
            Generating response...
          </Typography>
          {additionalText && (
            <Typography variant="body2" color="textSecondary">
              Ready in a few minutes to few hours depending on selected coverage and documents size.
            </Typography>
          )}
        </Box>
      </Paper>
    );
  };

  if ( !lastHumanMessage?.metadata?.parameters?.coverage ) return renderProgress();
  return renderProgress(true);
}
